import { ContentLink } from "@robe/client";
import { useModal, Box, Card, Typography } from "@xcorejs/ui";
import Popover from "design-system/robe/Popover";
import { PropsWithChildren } from "react";
import { InnovationBoxProps } from ".";
import { InnovationCard } from "./InnovationCard";
import { InnovationModal } from "./InnovationModal";

interface InnovationPopoverProps extends Pick<InnovationBoxProps, "openAs" | "backto" | "expandUp" | "innovation"> {
  intro: string;
  name: string;
}

export const InnovationPopover = ({
  openAs,
  children,
  expandUp = false,
  intro,
  name,
  innovation,
  backto,
}: PropsWithChildren<InnovationPopoverProps>) => {
  const [open] = useModal(InnovationModal);

  if (innovation && intro && name && innovation.values?.image) {
    return openAs === "link" ? (
      <ContentLink content={innovation} {...(backto && { queries: { backto } })}>
        <InnovationCard innovation={innovation} expandUp={expandUp} intro={intro} name={name}>
          {children}
        </InnovationCard>
      </ContentLink>
    ) : (
      <Box onClick={() => openAs === "modal" && open({ innovation })}>
        <InnovationCard innovation={innovation} expandUp={expandUp} intro={intro} name={name}>
          {children}
        </InnovationCard>
      </Box>
    );
  } else {
    return (
      <Popover
        popover={<Card width="41rem" maxWidth="100%" body={<Typography>Loading...</Typography>} />}
        _popover={{
          marginLeft: "2.5rem",
          pt: "0.6rem",
          transform: "translateX(-100%)",
        }}
      >
        {children}
      </Popover>
    );
  }
};
